export default __webpack_public_path__ + "static/media/nick_thumb.b3cf53ee.jpg";